export default "__VITE_ASSET__Dpme7beJ__"